/* import __COLOCATED_TEMPLATE__ from './delete-topic-disallowed.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();